// Application pack - jQuery bridge for theme + vanilla JS app logic
import $ from "jquery";
import "lite-youtube-embed";
import { QRCodeCanvas } from "@cheprasov/qrcode";
import { registerTooltipPlugin } from "../modules/tooltip";
import { initModals } from "../modules/modal";
import { initFormValidation } from "../modules/form-validation";
import { initCart } from "../modules/cart";

// Expose jQuery globally for theme (fos-theme, cca-theme) until themes are migrated
window.$ = window.jQuery = $;

// CSRF for fetch - also set up for jQuery (theme uses $.ajax)
$.ajaxSetup({
  beforeSend(xhr) {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
    if (token) xhr.setRequestHeader("X-CSRF-Token", token);
  },
});

// Tooltip and modal as jQuery plugins for theme compatibility
registerTooltipPlugin($);
$.fn.modal = function () {
  initModals();
  return this;
};

function domReady(fn) {
  if (document.readyState !== "loading") fn();
  else document.addEventListener("DOMContentLoaded", fn);
}

domReady(() => {
  // QR codes for barcodes
  document.querySelectorAll("[id*='line_item_barcode']").forEach((barcode) => {
    const prefix = "line_item_barcode-";
    const val = barcode.id.startsWith(prefix)
      ? barcode.id.slice(prefix.length)
      : barcode.id.split("-").slice(1).join("-");
    const qr = new QRCodeCanvas(val, { level: "Q", padding: 2 });
    barcode.src = qr.toDataUrl();
  });

  // Phone formatting
  const customerPhone = document.getElementById("customer_phone");
  if (customerPhone) {
    customerPhone.addEventListener("input", (e) => {
      const x = e.target.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    });
  }

  // Cart
  initCart();

  // Form validation
  initFormValidation();

  // Modals
  initModals();

  // Apple device detection
  const platform = navigator.platform;
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];
  if (macosPlatforms.indexOf(platform) === -1 && iosPlatforms.indexOf(platform) === -1) {
    document.querySelectorAll(".appleDeviceOnly").forEach((el) => (el.style.display = "none"));
  }

  // Recent orders row click
  document.querySelectorAll("#orders .recent_orders tr").forEach((row) => {
    row.addEventListener("click", () => {
      const link = row.querySelector("a");
      if (link) window.location = link.href;
    });
  });

  // Gift card remove
  const removeGiftCard = document.querySelector("#cart #remove_gift_card");
  if (removeGiftCard) {
    removeGiftCard.addEventListener("click", () => {
      const cardNum = document.getElementById("gift_card_card_number");
      const pin = document.getElementById("gift_card_pin");
      if (cardNum) cardNum.value = "";
      if (pin) pin.value = "";
    });
  }

  // Checkout button toggle
  document.querySelectorAll(".checkout-normal-button").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelector(".other-checkout-options")?.classList.toggle("flex");
    });
  });

  // Same-as-billing
  const sameAsBilling = document.getElementById("same_as_billing");
  const shippingWrappers = [
    "shipping_first_name_wrapper",
    "shipping_last_name_wrapper",
    "shipping_address_wrapper",
    "shipping_city_wrapper",
    "shipping_state_wrapper",
    "shipping_zip_wrapper",
  ];
  const billingToShipping = {
    customer_first_name: "customer_shipping_first_name",
    customer_last_name: "customer_shipping_last_name",
    customer_address: "customer_shipping_address",
    customer_city: "customer_shipping_city",
    customer_state: "customer_shipping_state",
    customer_zip: "customer_shipping_zip",
  };

  function copyBillingToShipping() {
    Object.entries(billingToShipping).forEach(([from, to]) => {
      const src = document.getElementById(from);
      const dst = document.getElementById(to);
      if (src && dst) dst.value = src.value;
    });
  }

  function toggleShipping(show) {
    shippingWrappers.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = show ? "" : "none";
    });
  }

  if (sameAsBilling && sameAsBilling.checked && !document.getElementById("cart")?.classList.contains("review")) {
    toggleShipping(false);
    copyBillingToShipping();
  }

  if (sameAsBilling) {
    sameAsBilling.addEventListener("change", () => {
      if (sameAsBilling.checked) {
        copyBillingToShipping();
        toggleShipping(false);
      } else {
        toggleShipping(true);
      }
    });
  }

  Object.keys(billingToShipping).forEach((billingId) => {
    const el = document.getElementById(billingId);
    if (el) {
      el.addEventListener("change", () => {
        if (sameAsBilling?.checked) {
          const shippingId = billingToShipping[billingId];
          const dst = document.getElementById(shippingId);
          if (dst) dst.value = el.value;
        }
      });
    }
  });

  // Update order email modal
  const openModal = document.getElementById("open-update-order-email-modal");
  const closeModal = document.getElementById("close-update-order-email-modal");
  const modalWrapper = document.getElementById("update-order-email-modal-wrapper");
  if (openModal) openModal.addEventListener("click", (e) => { e.preventDefault(); modalWrapper?.style.setProperty("display", "block"); });
  if (closeModal) closeModal.addEventListener("click", (e) => { e.preventDefault(); modalWrapper?.style.setProperty("display", "none"); });
  if (modalWrapper) {
    modalWrapper.addEventListener("click", (e) => {
      if (e.target === modalWrapper) modalWrapper.style.display = "none";
    });
  }

});
